import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { colors, font, pagePx } from "../theme/tokens";

const Footer = () => {
  return (
    <Box component="footer" sx={{ px: pagePx, py: 5, borderTop: `1px solid ${colors.border}`, backgroundColor: colors.bg }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        sx={{ justifyContent: "space-between", alignItems: "center", maxWidth: 1200, mx: "auto" }}
      >
        <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
          <Typography sx={{ fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.ink }}>
            Ibrahim Hamdani
          </Typography>
          <Typography sx={{ fontSize: 13, color: colors.inkMute }}>
            Software Engineer · Distributed Systems & Architecture
          </Typography>
        </Box>

        <Stack direction="row" spacing={2.5} alignItems="center">
          <a href="https://www.linkedin.com/in/ibrahimn9/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <BsLinkedin className="icon" style={{ fontSize: 20 }} />
          </a>
          <a href="https://github.com/ibrahimn9" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <BsGithub className="icon" style={{ fontSize: 20 }} />
          </a>
        </Stack>
      </Stack>
      <Typography sx={{ textAlign: "center", fontSize: 12, color: colors.inkMute, mt: 3, fontFamily: font.mono }}>
        © {new Date().getFullYear()} Ibrahim Hamdani — Built with React.
      </Typography>
    </Box>
  );
};

export default Footer;
